/*
 * custom-buy.js — GreenIT
 * Real add-to-cart for the custom "Buy Now" button (.custom_buy_btn) and the
 * sticky bar (.sticky_btn). The buttons keep their dynamic colour/label logic
 * (green = buy, red = on sale, orange = pre-order) from Liquid + CSS; this
 * script gives them a working add-to-cart that no longer depends on the Dawn
 * "Add to cart" button being present on the page.
 */
(function () {
  if (window.__greenitCustomBuyBound) return;
  window.__greenitCustomBuyBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.custom_buy_btn, .sticky_btn');
    if (!btn) return;

    e.preventDefault();
    if (btn.classList.contains('disabled') || btn.dataset.adding === '1') return;

    var addForm = document.querySelector('form[action*="/cart/add"]');
    var variantInput = addForm ? addForm.querySelector('[name="id"]') : document.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return;

    // Line-item properties, collected from two places. ORDER MATTERS: Fishbowl
    // prints the picking line as one concatenated string and truncates it, so
    // [data-cart-properties] is collected FIRST to put the charity flag at the
    // front where it always survives. The delivery-date app's "Order Estimation"
    // property lives in the /cart/add form and is collected second.
    var properties = {};
    function collectProperties(root) {
      if (!root) return;
      root.querySelectorAll('[name^="properties["]').forEach(function (el) {
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (m && el.value && !(m[1] in properties)) properties[m[1]] = el.value;
      });
    }
    document.querySelectorAll('[data-cart-properties]').forEach(function (el) { collectProperties(el); });
    collectProperties(addForm);

    // Quantity from the product-page quantity input (honours stock / quantity rules). Falls back to 1.
    var qtyInput = document.querySelector('input.quantity__input[id^="Quantity-"], .product__info-wrapper input[name="quantity"]');
    var quantity = qtyInput && qtyInput.value ? (parseInt(qtyInput.value, 10) || 1) : 1;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var item = { id: Number(variantInput.value), quantity: quantity };
    if (Object.keys(properties).length) item.properties = properties;

    var body = { items: [item] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    btn.dataset.adding = '1';
    btn.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { console.warn('Add to cart failed:', res.description || res.message); return; }
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-buy-btn', productVariantId: String(item.id), cartData: res });
          }
        } catch (err) {}
        if (cart && res.sections && typeof cart.renderContents === 'function') {
          cart.renderContents(res);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          if (typeof cart.open === 'function') cart.open();
        } else {
          window.location = '/cart';
        }
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        btn.dataset.adding = '';
        btn.classList.remove('loading');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  });
})();
